import { updateEnabledNotifications } from '@actions/user';
import {
  NotificationType,
  selectEnabledNotifications,
  selectUpdatingEnabledNotifications,
} from '@reducers/user/notifications';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function useEnabledNotifications() {
  const dispatch = useDispatch();
  const updatingEnabledNotifications = useSelector(selectUpdatingEnabledNotifications);
  const enabledNotifications = useSelector(selectEnabledNotifications);

  const toggleNotification = useCallback(
    (notificationType: NotificationType) => {
      dispatch(
        updateEnabledNotifications({
          ...enabledNotifications,
          [notificationType]: !enabledNotifications[notificationType],
        }),
      );
    },
    [enabledNotifications],
  );

  return { enabledNotifications, toggleNotification, updatingEnabledNotifications };
}
